@if (contactConfig) {
    <generic-list-manager [config]="contactConfig"></generic-list-manager>
}
